<template>
    <div class="input-group flex">
        <input v-if="is_mobile"
               :name="name"
               type="date"
               :value="date"
               @input="onChange"
               autocomplete="off"
               ref="dateField"
               class="input">
        <flat-pickr v-else
                    :value="date"
                    :config="useMonthPickr ? monthPluginConfig : config"
                    class="input"
                    :class="classes"
                    @on-change="onChange"
                    ref="flatpickr"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    :name="name"
        ></flat-pickr>

        <button v-if="hasResetButton" class="input-group-addon datepicker-icon" @click="reset">
            <i class="fal fa-times"></i>
        </button>

        <span v-if="hasIcon" class="input-group-addon datepicker-icon cursor-pointer" @click="openFlatPickr">
            <i class="fal fa-calendar-alt"></i>
        </span>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';
    import 'flatpickr/dist/plugins/monthSelect/style.css';

    export default {
        components: {flatPickr},

        props: {
            value: {},
            classes: {
                default: null
            },
            hasIcon: {
                default: true
            },
            altFormat: {
                default: 'd M Y'
            },
            dateFormat: {
                default: 'Y-m-d'
            },
            mode: {
                default: 'single'
            },
            minDate: {
                default: null
            },
            maxDate: {
                default: null
            },
            defaultDate: {
                default: null
            },
            disabled: {
                default: false
            },
            placeholder: {
                default: ''
            },
            hasResetButton: {
                type: Boolean,
                default: false
            },
            enableTime: {
                type: Boolean,
                default: false
            },
            useMonthPickr: {
                type: Boolean,
                default: false,
            },
            name: {
                type: String,
                default: null,

            }
        },

        data() {
            return {
                date: this.value,
                config: {
                    altInput: true,
                    altFormat: this.altFormat,
                    dateFormat: this.dateFormat,
                    mode: this.mode,
                    minDate: this.minDate,
                    maxDate: this.maxDate,
                    enableTime: this.enableTime
                },
                monthPluginConfig: {
                    plugins: [new monthSelectPlugin({
                        shorthand: false, //defaults to false
                        dateFormat: "F Y", //defaults to "F Y"
                        altFormat: "m.y", //defaults to "F Y"
                        theme: "light" // defaults to "light"
                    })]
                },
            }
        },

        computed: {
            is_mobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            }
        },

        methods: {
            onChange(selectedDates, dateStr, instance) {
                if (this.is_mobile) {
                    this.$emit('input', selectedDates.target.value);
                    return;
                }
                if (this.useMonthPickr) {
                    this.$refs.flatpickr.fp.close()
                }
                this.$emit('input', dateStr);
            },

            openFlatPickr() {
                if (this.is_mobile) {
                    this.$refs.dateField.focus();
                    this.$refs.dateField.click();
                    return;
                }
                this.$refs.flatpickr.fp.open()
            },
            reset() {
                this.$emit('input', null);
            },
        },

        watch: {
            value(value) {
                this.date = value
            },
            minDate(value) {
                this.config.minDate = value
            },
            maxDate(value) {
                this.config.maxDate = value
            }
        },
    }
</script>

<style scoped>
    .datepicker-icon {
        font-size: 1rem;
        padding: 0 0.75rem;
    }
</style>
